<div echarts
     [options]="options"
     [merge]="updateOptions"
     [initOpts]="initOptions"
     [autoResize]="true"
     (chartInit)="onChartInit($event)"
     (chartMagicTypeChanged)="onChartMagicTypeChanged($event)"
     style="height: 100%"
></div>
<button #expandBtn type="button" style="display: none" (click)="onExpandClick()">&nbsp;</button>
